import React from "react";
import { useCart } from "../../hooks";
import useSuppressChat from "../../hooks/useSuppressChat";
import ShoppingCart from "./ShoppingCart";

export default function ShoppingCartContainer() {
  const { cart, isError } = useCart();
  const [isOpen, setIsOpen] = React.useState(false);
  useSuppressChat(isOpen);

  const onOpen = React.useCallback(() => setIsOpen(true), []);

  const onClose = React.useCallback(() => setIsOpen(false), []);

  React.useEffect(() => {
    document.addEventListener("cart:open", onOpen);
    document.addEventListener("cart:close", onClose);
    window.addEventListener("popstate", onClose);

    return () => {
      document.removeEventListener("cart:open", onOpen);
      document.removeEventListener("cart:close", onClose);
      window.removeEventListener("popstate", onClose);
    };
  }, [onOpen, onClose]);

  if (isError) {
    return null;
  }

  if (!isOpen) {
    return null;
  }

  return <ShoppingCart cart={cart} onClose={onClose} />;
}
